import {
    AspectRatio,
    Button,
    Grid,
    IconAvatar,
    Image,
    Stack,
    Typography,
} from "@biggeo/bg-ui/lab";
import {
    ActionKeyOutline,
    DatabaseOutline,
    KeyOutline,
} from "@biggeo/bg-ui/lab/icons";
import {
    CenteredLayout,
    centeredLayoutClasses,
} from "@biggeo/bg-ui/lab/layouts";
import { Routes } from "../../navigation/redux/model";
import { useOpenModal } from "../../common/redux/hooks";
import EnterAccessKeyContainer from "../../data-access-keys/containers/EnterAccessKeyContainer";
import { useState } from "react";

const MyDataEmptyView = () => {
    const openModal = useOpenModal();

    const [reload, setReload] = useState(false);

    const onUseAccessKey = () =>
        openModal({
            modalType: "new-dialog",
            component: (
                <EnterAccessKeyContainer
                    reload={reload}
                    setReload={setReload}
                />
            ),
            dialogProps: {
                variant: "centered-medium",
            },
        });

    return (
        <CenteredLayout
            sx={{
                padding: 8,
                [`& .${centeredLayoutClasses.main}`]: {
                    marginY: "unset",
                },
                //To make this view scollable inside DataGridContainer overlayWrapper, to fix data loss
                overflowY: "auto",
            }}
        >
            <Stack gap={4} width="100%" height="100%">
                <Stack gap={0.5} width="100%">
                    <IconAvatar square>
                        <DatabaseOutline />
                    </IconAvatar>
                    <Typography variant="body1" fontWeight="bold">
                        Available Data
                    </Typography>
                    <Typography
                        variant="body2"
                        textColor="disabled.onContainer"
                    >
                        When you purchase datasets from BigGeos marketplace,
                        they will appear here. You can also enter access keys
                        here if a provider has given you access to their
                        datasets.
                    </Typography>
                </Stack>
                <Grid container gap={2} alignItems="center">
                    <Grid item>
                        <Button
                            startNode={<KeyOutline size="xs" />}
                            onClick={() => onUseAccessKey()}
                            variant="outlined"
                        >
                            Enter Access Key
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            startNode={<ActionKeyOutline size="xs" />}
                            href={Routes.marketplace}
                            target="_blank"
                        >
                            Explore Marketplace
                        </Button>
                    </Grid>
                </Grid>
                <AspectRatio variant="21/9" sx={{ flex: 1 }}>
                    <Image
                        alt={"Datalab Permissions"}
                        src="https://sabiggeomedia01.blob.core.windows.net/media/datascape-available-data.png"
                        width="100%"
                        height="100%"
                        sx={{
                            objectFit: "contain",
                        }}
                    />
                </AspectRatio>
            </Stack>
        </CenteredLayout>
    );
};

export default MyDataEmptyView;
